import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Card, Tabs } from 'antd';
import InfoView from '../../components/common/InfoView';
import Processors from '../Processors';
import MerchantUsers from './MerchantUsers';
import MerchantWebsites from './MerchantWebsites';
import Wallets from './Wallets';
import Can from '../../util/can';
import { TRANSACTIONS, USERS, MERCHANT_ACCOUNTS, MERCHANT_API_TOKENS } from '../../constants/resources';
import { getMerchantById } from '../../redux/actions/Data';
import Merchants from './index';
import Transactions from '../Transactions';
import TopGraphs from './TopGraphs';
import APIKeyCard from './APIKeyCard';

const DetailedView = () => {
  const dispatch = useDispatch();
  const { merchantId } = useParams();
  const { selectedMerchant, loading } = useSelector(({ data }) => data.selectedMerchantAccount);

  useEffect(() => {
    if (merchantId) {
      dispatch(getMerchantById(merchantId));
    }
  }, [dispatch, merchantId]);

  const { TabPane } = Tabs;

  return selectedMerchant && selectedMerchant._id && !loading ? (
    <Card className="gx-card" title={`Business Account (${selectedMerchant.name})`}>
      <Tabs defaultActiveKey="transactions" destroyInactiveTabPane={true}>
        <TabPane tab="Transactions" key="transactions">
          <>
            <TopGraphs merchantId={selectedMerchant._id} />
            <Can I="read" a={TRANSACTIONS}>
              <Transactions
                title="Transactions"
                transactionType=""
                transactionStatus=""
                merchantId={selectedMerchant._id}
              />
            </Can>
          </>
        </TabPane>
        <TabPane tab="Collections" key="collections">
          <Wallets selectedMerchant={selectedMerchant} />
        </TabPane>
        <TabPane tab="API Keys" key="tokensinfo">
          <Can I="read" a={MERCHANT_API_TOKENS}>
            <APIKeyCard merchantId={selectedMerchant._id} />
          </Can>
        </TabPane>
        <TabPane tab="Allowed Websites" key="websites">
          <Card>
            <MerchantWebsites />
          </Card>
        </TabPane>
        <TabPane tab="Account Access" key="users">
          <Can I="read" a={USERS}>
            <MerchantUsers merchant={selectedMerchant} />
          </Can>
        </TabPane>
        <TabPane tab="MID/PSP" key="mid">
          <Processors merchantId={selectedMerchant._id} />
        </TabPane>
        {selectedMerchant.enable_affiliate && (
          <TabPane tab="Affiliate" key="affiliates">
            <Can I="read" a={MERCHANT_ACCOUNTS}>
              <Merchants isDetailedView={true} />
            </Can>
          </TabPane>
        )}
      </Tabs>
      <InfoView />
    </Card>
  ) : (
    <Card className="gx-card" title="Loading...">
      <div>Loading merchant data...</div>
    </Card>
  );
};

export default DetailedView;
